export default __webpack_public_path__ + "static/media/question_10.58251bef.png";